import { ISearchService, TSearchQueryRequest } from "../service/SearchService";

export default class RunSearchQueryInteractor {
  private searchService: ISearchService;

  constructor({ searchService }: any) {
    this.searchService = searchService;
  }
  async execute(query: TSearchQueryRequest) {
    return this.searchService.search(query);
  }
}
